import axios from 'axios';

export default {
    search: function (request) {
      return axios.get('/api/techsupport/search', { params: request })
    },    
    send: function (data) {
      return axios.post('/api/techsupport/', data)
    }    
  }